import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzwm6yqar3: FaireProductEntity = {
  token: "p_rzwm6yqar3",
  type: "product",
  name: "Prosporous - Cordyceps, Lion’S Mane, Poria & Tremella",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/1d81cbf3128e6e428b30b4bf41ef0480cdaa371cb6168ade81e00e4eaaa9f40c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b8911fd02103a848a26e8053b2936571c16270ca02406897775bd0fc8c434e4.png",
    "https://cdn.faire.com/fastly/1ab7e013e9f0e3259e1ee2e06dc60c7b1e32b148b117b6be8ae61cf3fe761938.jpeg",
  ],
  priceDollars: 16.2,
  description:
    "\nThis invigorating synergy of fruiting body 1:1 mushrooms extracts supports your mind, lungs, liver, and skin. Lion’s mane is a neurotonic: it is the only mushroom known to support nerve growth. Cordyceps combats fatigue and improves respiratory function. Poria is a little known qi-tonic, providing vital upkeep for the liver. And tremella rejuvenates the skin and slows down it’s aging.\n\nThe mushrooms in ProSporous are organically cultivated in their favorite substrates (no starch, grains, or fillers) and 1:1 water extracted for bioavailability).\n\nBETA GLUCANS | 430mg per serving\n\nSERVINGS | 2 grams, 31 servings per package\n\n✓ Always grown outdoors in hoop houses, not in labs.\n\n✓ Triple tested for safety & Mushroom compounds\n*These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease or health condition. ",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:46.188Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
